<div class="modal-outer-wrapper mt-4">
    <div class="modal-inner-wrapper">
        <img *ngIf="svgType == 0" src="../../../../assets/images/sucess-icon.svg" alt="Success"/>
        <img *ngIf="svgType == 1" src="../../../../assets/images/failed-icon.svg" alt="Failed"/>
        <h3 class="my-0">{{headerText}}</h3>
        <p class="my-0">{{bodyText}}</p>
        <div class="flex flex-column gap-2 mb-4">
            <p-button [label]="buttonText" class="btn-continue" (onClick)="continue()"></p-button>
        </div>
    </div>
</div>